import AjaxService from '@services/AjaxService';

interface LegacyOption {
  key: string,
  value: string
}

interface SelectOptionNumber {
  text: string,
  value: number | string
}

interface OptionsResponse {
  options: LegacyOption[]
}

export default class VehicleManufacturerRepository {
  private readonly ajaxService: AjaxService;

  public constructor(ajaxService: AjaxService) {
    this.ajaxService = ajaxService;
  }

  public getVehicleManufacturerOptions(): Promise<SelectOptionNumber[]> {
    const url = '/de/Portal/ajax/dropdown/contentType/vehicleManufacturer/format/json';
    return this.ajaxService.getDropdownOptionsLegacy(url)
      .then((response: OptionsResponse) => {
        const options: SelectOptionNumber[] = [];
        for (const optionData of response.options) {
          options.push({
            value: parseInt(optionData.key, 10),
            text: optionData.value,
          })
        }
        return options;
      });
  }
}
